import React, { Component } from 'react';
import { func } from 'prop-types';
import { Route, Redirect } from 'react-router-dom';
import { get } from '../../../../container';

/**
 * Auth route
 * Custom react-router route
 */
class AuthRoute extends Component {
  static propTypes = {
    component: func.isRequired,
  };

  /**
   * {@inheritdoc}
   */
  render() {
    const { component: Component, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={props => !get('authenticator').isAuthenticated() ? <Component {...props} /> : <Redirect to={{ pathname: '/' }} />}
      />
    );
  }
}

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/modules/common/components/routes/AuthRoute.js